import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["badge"]
  static values = { url: String }

  initialize() {
    fetch(this.urlValue, {
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      redirect: "manual",
    })
      .then((response) => response.json())
      .then(({ count }) => {
        if (count > 0) {
          this.badgeTarget.textContent = count
          this.badgeTarget.classList.remove("invisible")
        }
      })
      .catch(() => {})
  }
}
